import { jsx as _jsx } from "react/jsx-runtime";
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import { useMediaQuery, useTheme } from '@mui/material';
export const BottomNavigation = ({ children }) => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const position = fullScreen ? 'fixed' : 'relative';
    const paddingX = fullScreen ? 4 : 0;
    const elevation = fullScreen ? 2 : 0;
    return (_jsx(Box, { sx: { minHeight: 40, marginTop: 2 }, children: _jsx(Paper, { sx: {
                position,
                paddingX,
                paddingY: 2,
                bottom: 0,
                left: 0,
                right: 0,
                display: 'flex',
                justifyContent: 'flex-end',
                gap: 2,
            }, elevation: elevation, children: children }) }));
};
